<template>
  <div id="frontale">
    <div class="arrow-left" :class="{ hidden: windowWidth < 768 }">
      <img :src="require('../../../assets/images/icone/freccia.png')" @click="scrollLeft()" />
    </div>
    <div class="arrow-right" :class="{ hidden: windowWidth < 768 }">
      <img :src="require('../../../assets/images/icone/freccia.png')" @click="scrollRight()" />
    </div>
    <el-row class="filtri">
      <el-col v-if="thinClipOnEnabled" :xs="{ span: 24, offset: 0 }" :sm="{ span: 7, offset: 1 }"
        :lg="{ span: 7, offset: 1 }">
        <el-col class="title" :span="24">TIPOLOGIA MODELLO</el-col>
        <el-col class="misure" :span="tipo === 'S' ? 12 : 8" :class="{ active: thinModels === 'C' }">
          <el-button type="text" @click="toggleThinModels('C')">
            <span>CLASSICO</span>
          </el-button>
        </el-col>

        <el-col class="misure" :span="tipo === 'S' ? 12 : 8" :class="{ active: thinModels === 'I' }">
          <el-button type="text" @click="toggleThinModels('I')">
            <span>AFFOGATO</span>
          </el-button>
        </el-col>

        <el-col v-if="tipo !== 'S'" class="misure" :span="8" :class="{ active: thinModels === 'A' }">
          <el-button type="text" @click="toggleThinModels('A')">
            <span>AFFOGATO CLIP</span>
          </el-button>
        </el-col>
      </el-col>
      <el-col :xs="{ span: 24, offset: 0 }" :sm="{ span: 14, offset: 1 }" :lg="{ span: 7, offset: 1 }">
        <el-col class="title" :span="24">MISURE</el-col>
        <el-col v-for="size in modelSizes" :key="size.size_description" class="misure" :span="8" :class="{
          active:
            `${size.size_eye}/${size.size_bridge}` == `${calibro}/${naso}`,
        }">
          <el-button type="text" @click="scegliMisura(size)">
            <span>{{ size | sizeLabel }}</span>
          </el-button>
        </el-col>
      </el-col>
      <el-col :xs="{ span: 24, offset: 0 }" :sm="{ span: 7, offset: 1 }" :lg="{ span: 6, offset: 1 }">
        <el-col class="title" :span="24">TIPO</el-col>
        <el-col class="misure" :span="frontType == 'A' || thinModels == 'A' ? 24 : 12" :class="{ active: tipo == 'V' }">
          <el-button type="text" @click="setLensesType('V')">
            <span>VISTA</span>
          </el-button>
        </el-col>
        <el-col v-if="frontType !== 'A' && thinModels !== 'A'" class="misure" :span="12"
          :class="{ active: tipo == 'S' }">
          <el-button type="text" @click="setLensesType('S')">
            <span>SOLE</span>
          </el-button>
        </el-col>
      </el-col>
    </el-row>
    <div class="modelli">
      <el-col class="modello-singolo" v-for="item in filteredFront" :key="item.U_THE_MODELLO" :class="{
        active:
          frontale != null
            ? item.U_THE_MODELLO == frontale.U_THE_MODELLO
            : '',
      }" @click="setFrontal(item)">
        <!-- <img :src="modelImageUrl(item.U_THE_MODELLO)" @click="setFrontal(item)" /> -->
        <div @click="setFrontal(item)">
          <model-image :model="item.U_THE_MODELLO.replace(/S|PL/g, '')" />
        </div>
        <span @click="setFrontal(item)">{{ item.U_THE_MODELLO }}</span>
      </el-col>
    </div>
  </div>
</template>

<script>
// import { mapActions } from "vuex";
import jslinq from "jslinq";
import _ from "lodash";
import ModelImage from "./ModelImage.vue";

export default {
  components: { ModelImage },
  data() {
    return {
      cercaModello: "",
      windowWidth: window.innerWidth,
      affogati: false,
    };
  },

  mounted: function () {
    // if (this.$route.params.id === undefined && _.isEmpty(this.frontale)) {
    //   this.getItems();
    // }
  },

  methods: {
    // ...mapActions("configurator/frontali", ["getItems", "getAllModelsSizes"]),
    // ...mapMutations(["setFrontal", "setSize", "setAsianFitting", "clearSize"]),

    getAllModelsSizes() {
      this.$store.dispatch("configurator/frontali/getAllModelsSizes");
    },


    toggleThinModels(val) {
      this.thinModels = val;
    },
    toggleAffogati(val) {
      this.affogati = val;
    },

    setFrontal(i) {
      this.$store.dispatch("configurator/frontali/setColor", "EP0001");
      this.$store.commit("configurator/resetClip");
      if (i.U_THE_TECNOLOGIA != "AFF") {
        this.$store.dispatch("configurator/aste/setColor", "EP0001");

        this.tintaUnita = false;
        this.frontType = 'C';
      }
      if (i.U_THE_TECNOLOGIA == "AFF" && i.U_THE_CUSMODEL !== "CPL") {
        this.$store.dispatch("configurator/aste/setColor", "EP0001");
        this.frontType = 'I';
      }
      if (i.U_THE_CUSMODEL == "CPL") {
        this.$store.dispatch("configurator/aste/setColor", "EP0001");
        this.frontType = 'A';
      }
      this.$store.dispatch("filterTemples", {
        sottolinea: i.U_THE_SOTTOLINEA
      });
      const corresponding = this.filteredTemples.find(
        (temple) =>
          temple.U_THE_COLORE == "EP0001" &&
          temple.misura == (this.misuraAste ? this.misuraAste : "140")
      );
      this.$store.commit("configurator/setTemplesColor", corresponding);

      this.$store.commit("configurator/setFrontal", i);
    },

    setSize(s) {
      this.$store.commit("configurator/setSize", s);
    },

    setAsianFitting(af) {
      this.$store.commit("configurator/setAsianFitting", af);
    },

    clearSize(s) {
      this.$store.commit("configurator/clearSize", s);
    },

    modelImageUrl(model) {
      return "https://media.thema-optical.com/3d_models/" + model + ".svg";
    },
    scrollLeft() {
      let container = document.getElementsByClassName("modelli");
      container[0].scrollLeft -= 250;
    },

    scrollRight() {
      let container = document.getElementsByClassName("modelli");
      container[0].scrollLeft += 250;
    },

    scegliMisura(val) {
      this.setSize(val);
    },

    setLensesType(val) {
      this.$store.commit("configurator/setLensesType", val);
    },

    setSunLensesModel(l) {
      this.$store.commit("configurator/setSunLensesModel", l);
    },
  },

  computed: {
    // ...mapState("configurator/frontali", ["items", "itemsSizes"]),
    // ...mapState(["frontale", "calibro", "naso", "asianFitting"]),
    thinClipOnEnabled() {
      return true;
    },

    filteredTemples() {
      return this.$store.state.filteredTemples;
    },

    misuraAste() {
      return this.$store.state.configurator.misuraAste;
    },

    thinModels: {
      get() {
        return this.$store.state.thinModels;
      },
      set(val) {
        this.$store.commit("setThinModels", val);
      }
    },

    tipo() {
      return this.$store.state.configurator.glassType;
    },

    frontale() {
      return this.$store.state.configurator.frontale;
    },
    calibro() {
      return this.$store.state.configurator.calibro;
    },
    tintaUnita: {
      get() {
        return this.$store.state.tintaUnita;
      },
      set(val) {
        this.$store.commit("setTintaUnita", val);
      }
    },
    naso() {
      return this.$store.state.configurator.naso;
    },
    asianFitting() {
      return this.$store.state.configurator.asianFitting;
    },

    frontType: {
      get() {
        return this.$store.state.frontType;
      },
      set(val) {
        this.$store.commit("setFrontType", val);
      }
    },

    items() {
      return this.$store.state.configurator.frontali.items;
    },
    itemsSizes() {
      return this.$store.state.configurator.frontali.itemsSizes;
    },
    queryFront() {
      return jslinq(this.items);
    },
    queryFrontSizes() {
      return jslinq(this.itemsSizes);
    },
    filteredFront() {
      // let self = this;
      let m = this.items.filter((i) => {
        if (this.tipo == "V") {
          return i.U_THE_CATMERC == "OVP";
        } else {
          return i.U_THE_CATMERC == "OSP";
        }
      });

      if (this.thinModels === "C") {
        m = m.filter((i) => {
          return i.U_THE_TECNOLOGIA != "AFF";
        });
      }
      if (this.thinModels === "I") {
        m = m.filter((i) => {
          return i.U_THE_TECNOLOGIA == "AFF" && i.U_THE_CUSMODEL !== "CPL";
        });
      }
      if (this.thinModels === "A") {
        m = m.filter((i) => {
          return i.U_THE_CUSMODEL == "CPL";
        });
      }
      // if (!this.thinClipOnEnabled) {
      //   m = m.filter((i) => {
      //     return i.U_THE_SOTTOLINEA != 'TIPO_A' || i.U_THE_SOTTOLINEA != 'TIPO_B';
      //   });
      // }

      // if (this.thinModels && this.thinClipOnEnabled) {
      //   m = m.filter((i) => {
      //     return i.U_THE_SOTTOLINEA == 'TIPO_A' || i.U_THE_SOTTOLINEA == 'TIPO_B';
      //   });
      // }

      m.sort(function compareFn(a, b) {
        const isVista = self.tipo === "V";

        const aPL = a.U_THE_MODELLO.endsWith("PL");
        const bPL = b.U_THE_MODELLO.endsWith("PL");

        // Se siamo in "VISTA", "PL" e versioni senza suffisso devono stare insieme
        if (isVista) {
          if (aPL && !bPL) return -1;
          if (!aPL && bPL) return 1;
        } else {
          // Se NON è vista, "PL" deve stare prima di tutti
          if (aPL && !bPL) return -1;
          if (!aPL && bPL) return 1;
        }

        // Rimuovo prefissi e suffissi per ottenere il numero
        let numA = a.U_THE_MODELLO.replace("MYC-", "").replace("PL", "");
        let numB = b.U_THE_MODELLO.replace("MYC-", "").replace("PL", "");

        if (!isVista) {
          numA = numA.replace("S", "");
          numB = numB.replace("S", "");
        }

        return parseInt(numA, 10) - parseInt(numB, 10);
      });


      return m;
    },
    modelSizes() {
      if (!_.isEmpty(this.frontale)) {
        return this.queryFrontSizes
          .where((s) => {
            return s.U_THE_MODELLO == this.frontale.U_THE_MODELLO;
          })
          .toList();
      }

      return [];
    },
  },

  watch: {
    async frontale(newVal) {
      if (newVal) {
        if (!_.isEmpty(this.frontale)) {
          await this.getAllModelsSizes();
          let a = this.queryFrontSizes
            .where((c) => {
              return (
                c.U_THE_MODELLO == this.frontale.U_THE_MODELLO &&
                c.size_eye == this.calibro &&
                c.size_bridge == this.naso
              );
            })
            .toList();
          if (a.length == 0) {
            this.clearSize();
            let b = this.queryFrontSizes.firstOrDefault((c) => {
              return (
                c.U_THE_MODELLO == this.frontale.U_THE_MODELLO &&
                (c.size_description == "REGULAR" || c.size_description == 'MEDIUM')
              );
            });
            this.setSize(b);
          } else {
            this.setSize(a[0]);
          }
        }
      }
    },

    tipo(newV, oldV) {
      let catMerc = "";
      if (newV == "V") {
        catMerc = "OVP";
      } else if (newV == "S") {
        catMerc = "OSP";
      }

      if (oldV == "S" && newV == "V") {
        this.setSunLensesModel(null);
      }

      if (this.items) {
        const m = this.items.filter((i) => {
          return (
            i.U_THE_MODELLO.replace("S", "") ==
            this.frontale.U_THE_MODELLO.replace("S", "") &&
            i.U_THE_CATMERC == catMerc
          );
        });

        if (m.length > 0) {
          this.setFrontal(m[0]);
        }

        if (this.itemSizes && this.calibro && this.naso) {
          const s = this.itemSizes.filter((is) => {
            return (
              is.ItemCode == m[0].ItemCode &&
              parseInt(is.size_eye) == this.calibro &&
              parseInt(is.size_bridge) == this.naso
            );
          });

          if (s.length > 0) {
            this.setSize(s[0]);
          }
        }
      }
    },
  },
};
</script>

<style lang="less">
#frontale {
  .filtri {
    display: flex;

    .cerca-modello {
      width: 20%;
    }

    .misure-modello {
      padding: 0% 5%;
    }
  }

  @media (max-width: 767px) {
    .filtri {
      flex-direction: column;
    }

    .filtri>div {
      height: 50% !important;
      // display: inline-block;
    }

    .modelli {
      height: 100%;
      flex-wrap: wrap;
      background-color: @--color-text-secondary;

      .modello-singolo {
        width: 50%;
        padding-top: 10px;

        img {
          width: 100%;
          // padding: 10px 50px;
          cursor: pointer;
        }

        span {
          cursor: pointer;
          padding-bottom: 15px;
          width: 100%;
        }
      }
    }
  }

  @media (min-width: 768px) {

    // .filtri > div {
    //   height: 50% !important;
    //   // display: inline-block;
    // }
    .modelli {
      height: 80%;
      padding-left: 75px;
      padding-right: 75px;

      .modello-singolo {
        justify-content: center;

        img {
          width: 200px;
          padding: 10px 30px;
          cursor: pointer;
        }

        span {
          cursor: pointer;
          padding: 10px 30px;
          width: 200px;
        }
      }
    }
  }

  .modelli::-webkit-scrollbar {
    display: none;
  }

  .modelli {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    scroll-behavior: smooth;

    .modello-singolo {
      display: flex;
      flex-direction: column;
      padding-left: 20px;
      padding-right: 20px;
      cursor: pointer;

      span,
      svg {
        transition: all 0.2s ease;
      }

      &.active {
        span {
          color: @--color-warning;
        }

        svg {
          fill: @--color-warning !important;
        }
      }
    }
  }
}
</style>